module.exports = __webpack_public_path__ + "img/help_other_hfp@3x.6ab99e94.png";